import React, { useMemo, useState } from 'react';
import { ImCross, ImSpinner2 } from 'react-icons/im';
import avatar from '../../assests/logo.png';
import './SearchChatBox.css';
import { BiSearch } from 'react-icons/bi';

const SearchChatBox = ({
  showPanel,
  setShowPanel,
  searchText,
  setSearchText,
  teacherList,
  isLoading,
  setSelectedTeacher,
}) => {
  const [searchResults, setSearchResults] = useState(teacherList || []);

  useMemo(() => {
    if (searchText === '') return setSearchResults(teacherList);
    setSearchResults(() => {
      return teacherList.filter((teacher) => teacher.first_name.toLowerCase().includes(searchText.toLowerCase()));
    });
  }, [searchText, teacherList]);

  return (
    <div className="search-container" onClick={(e) => e.stopPropagation()}>
      <div className="search-box-input">
        <BiSearch className="search-icon" />
        <input
          type="text"
          placeholder="Search..."
          value={searchText}
          onClick={() => setShowPanel(true)}
          onChange={(e) => setSearchText(e.target.value)}
          className="search-input"
        />
        {searchText !== '' && (
          <ImCross style={{ height: '12px' }} className="clear-icon" onClick={() => setSearchText('')} />
        )}
      </div>

      {showPanel && (
        <div className="search-dropdown">
          <div className="search-results">
            {isLoading ? (
              <div className="loading-container">
                <ImSpinner2 className="loading-icon" />
                <p className="loading-text">Loading...</p>
              </div>
            ) : (
              searchResults.map((teacher, index) => (
                <div
                  key={index}
                  onClick={() => {
                    setSelectedTeacher({
                      ...teacher,
                      id: teacher.user_id,
                    });
                    setShowPanel(false);
                    setSearchText(teacher.first_name);
                  }}
                  className="search-result-item"
                >
                  <img src={teacher.imageId || avatar} alt="profile" className="search-result-avatar" />
                  <h2 className="search-result-name mb-0">
                    {teacher.first_name} {teacher.middle_name} {teacher.last_name}
                  </h2>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchChatBox;
